import { render, staticRenderFns } from "./result_sjh.vue?vue&type=template&id=ec9b2586&scoped=true"
import script from "./result_sjh.vue?vue&type=script&lang=js"
export * from "./result_sjh.vue?vue&type=script&lang=js"
import style0 from "./result_sjh.vue?vue&type=style&index=0&id=ec9b2586&prod&lang=scss&scoped=true"
import style1 from "./result_sjh.vue?vue&type=style&index=1&id=ec9b2586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9b2586",
  null
  
)

export default component.exports